<template>
  <div id="calendar-view">
    <v-app id="inspire">
      <v-row class="fill-height">
        <v-col>
          <v-sheet height="64">
            <v-toolbar
              flat
              color="white"
            >
              <v-btn
                outlined
                class="mr-4"
                color="grey darken-2"
                @click="setToday"
              >
                Today
              </v-btn>
              <v-btn
                fab
                text
                small
                color="grey darken-2"
                @click="prev"
              >
                <v-icon small>
                  mdi-chevron-left
                </v-icon>
              </v-btn>
              <v-btn
                fab
                text
                small
                color="grey darken-2"
                @click="next"
              >
                <v-icon small>
                  mdi-chevron-right
                </v-icon>
              </v-btn>
              <v-toolbar-title v-if="$refs.calendar">
                {{ $refs.calendar.title }}
              </v-toolbar-title>
              <v-spacer />
              <v-dialog
                id="addEvent"
                v-model="dialog"
                max-width="800px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>
                      mdi-plus-circle-outline
                    </v-icon>
                  </v-btn>
                </template>
                <v-card id="addEvent">
                  <v-card-title>
                    <span class="text-h5"> Add Events </span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="editedEvent.name"
                            label="Event Name"
                          />
                        </v-col>
                        <v-col
                          cols="6"
                          sm="6"
                          md="4"
                        >
                          <v-menu
                            ref="start_date_menu"
                            v-model="start_date_menu"
                            :close-on-content-click="false"
                            :return-value.sync="event_start_date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="event_start_date"
                                label="Start Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <v-date-picker
                              v-model="event_start_date"
                              no-title
                              scrollable
                            >
                              <v-spacer />
                              <v-btn
                                text
                                color="primary"
                                @click="start_date_menu = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.start_date_menu.save(event_start_date)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col>
                          <v-menu
                            ref="start_time_menu"
                            v-model="start_time_menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="event_start_time"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="event_start_time"
                                label="Start Time"
                                prepend-icon="mdi-clock-time-four-outline"
                                v-bind="attrs"
                                readonly
                                v-on="on"
                              />
                            </template>
                            <v-time-picker
                              v-if="start_time_menu"
                              v-model="event_start_time"
                              full-width
                              @click:minute="$refs.start_time_menu.save(event_start_time)"
                            />
                          </v-menu>
                        </v-col>
                        <v-col
                          cols="6"
                          sm="6"
                          md="4"
                        >
                          <v-menu
                            ref="end_date_menu"
                            v-model="end_date_menu"
                            :close-on-content-click="false"
                            :return-value.sync="event_end_date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="event_end_date"
                                label="End Date"
                                prepend-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                              />
                            </template>
                            <v-date-picker
                              v-model="event_end_date"
                              no-title
                              scrollable
                            >
                              <v-spacer />
                              <v-btn
                                text
                                color="primary"
                                @click="end_date_menu = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.end_date_menu.save(event_end_date)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col>
                          <v-menu
                            ref="end_time_menu"
                            v-model="end_time_menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="event_end_time"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="event_end_time"
                                label="End Time"
                                prepend-icon="mdi-clock-time-four-outline"
                                v-bind="attrs"
                                readonly
                                v-on="on"
                              />
                            </template>
                            <v-time-picker
                              v-if="end_time_menu"
                              v-model="event_end_time"
                              full-width
                              @click:minute="$refs.end_time_menu.save(event_end_time)"
                            />
                          </v-menu>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="editedEvent.link"
                            label="Event Link"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="editedEvent.location"
                            label="Event Location"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-select
                            v-model="editedEvent.type"
                            :items="['Meeting','Competition','Training','Travel','Networking','Sponsorship','Jobs Fair']"
                            :menu-props="{ top: true, offsetY: true }"
                            label="Type"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-text-field
                            v-model="editedEvent.description"
                            label="Event Description"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="close"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="save"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="filter"
                max-width="800px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon small>
                      mdi-filter
                    </v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Filter by Type</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                          md="4"
                        >
                          <v-select
                            v-model="filterType"
                            :items="['All','Meeting','Competition','Training','Travel','Networking','Sponsorship','Jobs Fair', 'Todo']"
                            :menu-props="{ top: true, offsetY: true }"
                            label="Type"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="closeFilter"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="saveFilter(filterType)"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-menu
                bottom
                right
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    color="grey darken-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span>{{ typeToLabel[type] }}</span>
                    <v-icon right>
                      mdi-menu-down
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="type = 'day'">
                    <v-list-item-title>Day</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'week'">
                    <v-list-item-title>Week</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'month'">
                    <v-list-item-title>Month</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = '4day'">
                    <v-list-item-title>4 days</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-sheet>
          <v-sheet height="600">
            <v-calendar
              ref="calendar"
              v-model="focus"
              color="primary"
              :events="current_events"
              :event-color="getEventColor"
              :type="type"
              @click:event="showEvent"
              @click:more="viewDay"
              @click:date="viewDay"
            />
            <v-menu
              v-model="selectedOpen"
              :close-on-content-click="false"
              :activator="selectedElement"
              offset-x
            >
              <v-card
                color="grey lighten-4"
                min-width="350px"
                flat
              >
                <v-toolbar
                  :color="selectedEvent.color"
                  dark
                >
                  <v-btn icon>
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-toolbar-title
                    v-html="selectedEvent.name"
                  />
                  <v-spacer />
                  <v-btn icon>
                    <v-icon>mdi-heart</v-icon>
                  </v-btn>
                  <v-btn icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text>
                  <span v-html="selectedEvent.details" />
                </v-card-text>
                <v-row>
                  <v-card-actions>
                    <v-btn
                      icon
                      @click="show = !show"
                    >
                      <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                    <v-spacer />
                    <v-btn
                      text
                      color="secondary"
                      @click="selectedOpen = false"
                    >
                      Cancel
                    </v-btn>
                    <v-expand-transition>
                      <div v-show="show">
                        <v-divider />
                        <template v-if="selectedEvent.description">
                          <v-card-text>
                            {{ selectedEvent.description }}
                          </v-card-text>
                        </template>
                        <template v-else>
                          <v-card-text>
                            There is no description for this event.
                          </v-card-text>
                        </template>
                        <template v-if="selectedEvent.type">
                          <v-card-text>
                            Type: {{ selectedEvent.type }}
                          </v-card-text>
                        </template>
                        <template v-if="selectedEvent.link">
                          <v-card-text>
                            Click <a :href="selectedEvent.link">here</a>
                          </v-card-text>
                        </template>
                      </div>
                    </v-expand-transition>
                  </v-card-actions>
                </v-row>
              </v-card>
            </v-menu>
          </v-sheet>
        </v-col>
      </v-row>
    </v-app>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import DatetimePicker from 'vuetify-datetime-picker'
  export default {
    name: 'CalendarView',
    components: {
      DatetimePicker,
    },
    data: () => ({
      includeTodos: false,
      dialog: false,
      filter: false,
      filterType: null,
      event_start_date: null,
      event_start_time: null,
      start_time_menu: false,
      start_date_menu: false,
      end_date_menu: false,
      end_time_menu: false,
      event_end_date: null,
      event_end_time: null,
      editedEvent: {
        name: '',
        start: '',
        end: '',
        color: null,
        type: null,
        location: null,
        link: null,
        timed: true,
        description: null,
      },
      defaultEvent: {
        name: '',
        start: new Date(),
        end: new Date(),
        type: null,
        location: 'Online',
        link: null,
        timed: true,
        description: null,
      },
      show: false,
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        '4day': '4 Days',
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      current_events: [],
      colors: [
        'blue',
        'indigo',
        'deep-purple',
        'cyan',
        'green',
        'orange',
        'grey darken-1',
      ],
      names: [
        'Meeting',
        'Competition',
        'Training',
        'Travel',
        'Networking',
        'Sponsorship',
        'Jobs Fair',
      ],
    }),
    watch: {
      dialog (val) {
        val || this.close()
      },
    },
    created () {
      this.update()
    },
    mounted () {
      this.$refs.calendar.checkChange()
    },
    computed: {
      ...mapGetters([
        'getEvents',
        'getEventsColors',
        'getEventsTypes',
        'getTodos',
      ]),
    },
    methods: {
      ...mapActions([
        'createNewEvent',
      ]),
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          setTimeout(() => (this.selectedOpen = true), 10)
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          setTimeout(open, 10)
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      update () {
        this.current_events = this.getEvents
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedEvent = Object.assign({}, this.defaultEvent)
        })
      },
      closeFilter () {
        this.filter = false
      },
      findEventColor (type) {
        return this.colors[this.names.indexOf(type)]
      },
      save () {
        if (this.event_start_date && this.event_start_time) {
          var eventStart = new Date(this.event_start_date + ' ' + this.event_start_time)
        } else if (this.event_start_date) {
          eventStart = this.event_start_date
        } else {
          eventStart = new Date()
        }

        if (this.event_end_date && this.event_end_time) {
          var eventEnd = new Date(this.event_start_date + ' ' + this.event_start_time)
        } else if (this.event_end_date) {
          eventEnd = this.event_end_date
        } else {
          eventEnd = null
        }

        this.editedEvent.start = eventStart
        this.editedEvent.end = eventEnd
        this.editedEvent.color = this.findEventColor(this.editedEvent.type)
        this.createNewEvent(this.editedEvent)
        this.update()
        this.dialog = false
      },
      saveFilter (type) {
        if (type === 'All') {
          this.update()
        } else {
          var eventList = this.getEvents.filter(item => item.type === type)
          this.current_events = eventList
        }
        this.filter = false
      },
      updateRange ({ start, end }) {
        const currentEvents = []

        const min = new Date(`${start.date}T00:00:00`)
        const max = new Date(`${end.date}T23:59:59`)
        const days = (max.getTime() - min.getTime()) / 86400000
        const eventCount = this.rnd(days, days + 20)

        for (let i = 0; i < eventCount; i++) {
          const allDay = this.rnd(0, 3) === 0
          const firstTimestamp = this.rnd(min.getTime(), max.getTime())
          const first = new Date(firstTimestamp - (firstTimestamp % 900000))
          const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
          const second = new Date(first.getTime() + secondTimestamp)
          const selection = this.rnd(0, this.names.length - 1)

          currentEvents.push({
            name: this.names[selection],
            start: first,
            end: second,
            color: this.colors[selection],
            timed: !allDay,
          })
        }

        this.currentEvents = currentEvents
      },
      addTodosAsEvent () {
        var todos = this.getTodos
        var i = 0
        var len = this.getTodos.length
        for (; i < len; i++) {
          var todo = todos[i]
          var assignment = ''
          assignment += todo.tags.join(' + ')
          var newEvent = {
            name: todo.title,
            color: this.getTodoColor(todo.priority),
            start: todo.inDate,
            description: 'Assigned to: ' + assignment,
            type: 'Todo',
          }
          this.current_events.push(newEvent)
        }
      },
      getTodoColor (wearStatus) {
        if (wearStatus === 'High') return '#f5365c'
        else if (wearStatus === 'Medium') return '#ffbb33'
        else if (wearStatus === 'Low') return '#5e72e4'
        else return '#11cdef'
      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
    },
  }
</script>
